import { Indicator } from 'mint-ui'
import { Loading } from 'element-ui'

const loadingIndicator = {
  //mint-ui
  /**
   * 显示加载中图标
   * @param {*} text 文本内容
   * @param {*} type 加载图标类型
   */
  open(text, type) {
    let obj = {
      text: text ? text : '加载中...',
      type: type ? type : 'snake'
    }
    Indicator.open(obj)
  },
  /**
   * 关闭加载中图标
   */
  close() {
    //Indicator设置open之后直接设置close会无效，加一个延时可以解决该问题（原因未知）
    window.setTimeout(() => {
      Indicator.close()
    }, 1)
  },

  //element
  eleOpen(text = 'Loading') {
    const loading = Loading.service({
      lock: true,
      text: text,
      spinner: 'el-icon-loading',
      background: 'rgba(0, 0, 0, 0.7)'
    })
    return loading
  }
}
export default loadingIndicator



// WEBPACK FOOTER //
// ./src/api/loadingIndicator.js